module.exports = __webpack_public_path__ + "static/media/kp.fc45ba59.svg";